<template>
  <div>
    <dashboard-header :text="$t('setting.updateSetting') " :on-back="onGoBack"/>
    <div class="d-flex justify-center align-center">
      <v-card elevation="0"
              class="card-border-10 w-75">
        <v-card class="m-4"
                outlined>
          <div class="d-flex custom-card-head p-4">
            <div class="d-inline text-sm-h5 ">{{ $t("nav.about") }}</div>
          </div>
          <v-divider class="m-0"></v-divider>
          <div class="px-6 pt-6">
            <div class="d-flex">
              <div class="text-h6 mark-title">*</div>
              <p class="ms-1 text-sm-h5">{{ $t('setting.timeRefresh') }}</p>
            </div>

            <v-text-field
                :placeholder="placeholderTimeRefresh"
                v-model="setting.timeRefresh"
                type="number"
                outlined
                rows="1"
            />

            <div class="d-flex">
              <div class="text-h6 mark-title">*</div>
              <p class="ms-1 text-sm-h5">{{ $t('setting.androidTabletVersionCode') }}</p>
            </div>
            <v-text-field
                :placeholder="placeholderVersion"
                v-model="setting.androidTabletVersionCode"
                type="number"
                outlined
                rows="1"
            />
            <div class="d-flex">
              <div class="text-h6 mark-title">*</div>
              <p class="ms-1 text-sm-h5">{{ $t('setting.androidDoctorVersionCode') }}</p>
            </div>
            <v-text-field
                :placeholder="placeholderVersion"
                v-model="setting.androidDoctorVersionCode"
                type="number"
                outlined
                rows="1"
            />
            <div class="d-flex">
              <div class="text-h6 mark-title">*</div>
              <p class="ms-1 text-sm-h5">{{ $t('setting.iosDoctorVersionCode') }}</p>
            </div>
            <v-text-field
                :placeholder="placeholderVersion"
                v-model="setting.iosDoctorVersionCode"
                type="number"
                outlined
                rows="1"
            />
            <div class="d-flex">
              <div class="text-h6 mark-title">*</div>
              <p class="ms-1 text-sm-h5">{{ $t('setting.androidTabletApkUrl') }}</p>
            </div>
            <v-textarea
                v-model="setting.androidTabletApkUrl"
                type="string"
                rows="3"
                outlined
            />
            <div class="d-flex align-center">
              <v-switch
                  inset
                  v-model="setting.enableSMS"
                  @change="getValueEnableSMS"
              ></v-switch>
              <div class="text-sm-h5">{{ $t('setting.enableSMS') }}</div>
            </div>

          </div>

          <div class=" m-4">
            <v-btn
                elevation="0"
                class="no-uppercase btn-custom-primary"
                @click="checkForm"
            >{{ $t('ui.save') }}
            </v-btn>
          </div>
        </v-card>
      </v-card>
    </div>
  </div>
</template>

<script>
import {API2} from "../../api";
import i18n from "../../lang/i18n";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";

export default {
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      setting: {},
      enableSMS: false,
    };
  },
  computed: {
    placeholderTimeRefresh() {
      return this.$t("setting.enterTimeRefresh")
    },
    placeholderVersion() {
      return this.$t("setting.enterVersion")
    }
  },
  mounted() {
    this.onTab()
  },
  methods: {
    onTab() {
      this.getData()
    },
    onGoBack() {
      this.openTab(0)
    },
    async getData() {
      let res = await this.get(API2.SETTING)
      if (!res) return
      if (res) {
        this.setting = res;
      }
    },
    checkForm() {
      if (!this.setting.timeRefresh || this.setting.timeRefresh.toString() === "0") {
        this.showToast("warning",
            i18n.t("warning.warning"),
            i18n.t("warning.enterTimeRefresh")
        )
        return;
      }
      if (!this.setting.androidTabletVersionCode) {
        this.showToast("warning",
            i18n.t("warning.warning"),
            i18n.t("warning.enterVersion")
        )
        return;
      }
      if (!this.setting.androidDoctorVersionCode) {
        this.showToast("warning",
            i18n.t("warning.warning"),
            i18n.t("warning.enterVersion")
        )
        return;
      }
      if (!this.setting.iosDoctorVersionCode) {
        this.showToast("warning",
            i18n.t("warning.warning"),
            i18n.t("warning.enterVersion")
        )
        return;
      }
      this.onSave();
    },
    async onSave() {

      let res = await this.put(API2.SETTING, {
        timeRefresh: this.setting.timeRefresh,
        enableSMS: this.setting.enableSMS ? 1 : 0,
        androidTabletVersionCode: this.setting.androidTabletVersionCode,
        androidDoctorVersionCode: this.setting.androidDoctorVersionCode,
        iosDoctorVersionCode: this.setting.iosDoctorVersionCode,
        androidTabletApkUrl: this.setting.androidTabletApkUrl,
      })
      if (!res) return
      this.showToast("success",
          i18n.t("base.notification"),
          i18n.t("setting.updateSettingSuccessful")
      )
      this.openTab(0)
    },
    getValueEnableSMS(newValue) {
      this.setting.enableSMS = newValue ? 1 : 0
    }
  }
};
</script>
<style scoped>
.v-input {
  font-size: 22px;
}

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}
</style>
